// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_ej-2";
export var aiChatCartContainerExit = "_ej-4";
export var aiChatContainerLarge = "_ej-0";
export var aiChatContainerSmall = "_ej-1";
export var aiChatIcon = "_ej-6";
export var slideInFromRight = "_ej-3";
export var slideOutToRight = "_ej-5";